// extracted by mini-css-extract-plugin
module.exports = {"hideOnMobileWrapper":"SaleActive_hideOnMobileWrapper__aJmpc"};